import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopMenuComponent } from './top-menu.component';
import { SharedModule } from '../shared/shared.module';
import { DropdownClickDirective } from './dropdown-click.directive';
import { RadioButtonUnitsComponent } from './radio-button-units/radio-button-units.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShareProjectComponent } from './share-project/share-project.component';
import { ImportCsvComponent } from './import-csv/import-csv.component';
import { ChangeUnitsComponent } from './change-units/change-units.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { SaveProjectComponent } from './save-project/save-project.component';
import { DownloadPdfComponent } from './download-pdf/download-pdf.component';
import { ModalModule } from '../modal/modal.module';
import { ExportCsvComponent } from './export-csv/export-csv.component';

@NgModule({
    declarations: [
        TopMenuComponent,
        DropdownClickDirective,
        RadioButtonUnitsComponent,
        ShareProjectComponent,
        NewProjectComponent,
        SaveProjectComponent,
        ChangeUnitsComponent,
        RadioButtonUnitsComponent,
        ImportCsvComponent,
        DownloadPdfComponent,
        ExportCsvComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        SharedModule,
        ModalModule
    ],
    exports: [TopMenuComponent]
})
export class TopMenuModule { }
